import { PossibleBusinessObject } from '@iotv/iotv-v3-types'
import { ModelCommon } from './ModelCommon'
import { UserAttributeDefs } from '../types/ModelTypes'

const typeName = 'ProductModel'

class ProductModel extends ModelCommon {
  //currently can't inhertit from Thing as constructor just expects ob. A consequence of 'can't user prototype.constructor.name in Webpack'
  constructor(ob: PossibleBusinessObject) {
    super(ob.type || typeName, ob)
  }
  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
    }
  }
}

export { ProductModel }
